import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {Breadcrumb,} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import CloseBoxDetail from "../../components/open_box/CloseBoxDetail";

class OpenBoxDetail extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>Bisttros - Vender</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/sales'>Finanzas</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section as={Link} to='/sales/boxes'>Cierres de Caja</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Caja Actual</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <CloseBoxDetail id={this.props.match.params.id}/>
            </div>
        );
    }
}

export default withRouter(OpenBoxDetail);



// WEBPACK FOOTER //
// ./src/containers/sale/OpenBoxDetail.js